import {
  type EWithdrawalEntryPoint,
  type EWithdrawalField,
  type EWithdrawalSubmitFailure,
  type IWithdrawalItemInput,
} from '@mahawi/eshop-common/dist/src/types';

export enum EWithdrawalStep {
  FORM = 'form',
  REVIEW = 'review',
  DONE = 'done',
}

export interface IWithdrawalOrderItem {
  productUuid: string;
  name: string;
  count: number;
}

export interface IWithdrawalOrderContext {
  uuid: string;
  shortCode: string;
  email: string;
  name: string;
  items: IWithdrawalOrderItem[];
}

export interface IWithdrawalDraft {
  name: string;
  orderNumber: string;
  orderEmail: string;
  confirmationEmail: string;
  confirmationEmailEdited: boolean;
  reason: string;
  itemsDescription: string;
  items: Record<string, number>;
}

interface IWithdrawalResult {
  referenceCode: string;
  receivedAt: string;
  confirmationEmail: string;
}

export interface IWithdrawalSubmitPayload {
  submissionKey: string;
  languageCode: string;
  entryPoint: EWithdrawalEntryPoint;
  name: string;
  orderNumber: string;
  orderEmail: string;
  confirmationEmail: string;
  reason: string | null;
  itemsDescription: string | null;
  orderUuid: string | null;
  items: IWithdrawalItemInput[];
}

export interface IWithdrawalSubmit {
  payload: IWithdrawalSubmitPayload;
}

export type TWithdrawalSubmitResponsePayload =
  | {
      ok: true;
      withdrawal: IWithdrawalResult;
    }
  | {
      ok: false;
      reason: EWithdrawalSubmitFailure;
      fields?: EWithdrawalField[];
    };

interface IWithdrawalSubmitResponse {
  type: string;
  payload: TWithdrawalSubmitResponsePayload;
}

export type WithdrawalSubmitCallback = (
  arg0: IWithdrawalSubmitResponse,
) => void;

export interface IWithdrawalState {
  order: IWithdrawalOrderContext | null;
  entryPoint: EWithdrawalEntryPoint;
  step: EWithdrawalStep;
  draft: IWithdrawalDraft;
  submissionKey: string | null;
  result: IWithdrawalResult | null;
  error: EWithdrawalSubmitFailure | null;
  invalidFields: EWithdrawalField[];
  isSubmitting: boolean;
}
